




  import Vue from 'vue';

  export default Vue.extend({
    name: 'EntetePage',
    props: {
      titre: {
        type: String,
        default: '',
      },
    },
  });
